export default "__VITE_ASSET__052606c0__"